// extracted by mini-css-extract-plugin
export var paymentTypes = "paymentTypes-module--paymentTypes--xhp3Q";
export var item = "paymentTypes-module--item--24Rml";
export var btn = "paymentTypes-module--btn--3sx6B";
export var activeIcon = "paymentTypes-module--activeIcon--jTfFH";
export var active = "paymentTypes-module--active--38CfD";
export var input = "paymentTypes-module--input--29T0Z";